import {PluginCommand as command_deployment} from "../src/commands/deployment"

export const commands = {
  "deployment": {PluginCommand: command_deployment},
}